import { appendHtml } from "../../lib/append-html.js";
import { createChannelDescriptor } from "./channel-descriptor.js";
import { SKETCH_HOST_ID } from "../../constants.js";

export const createCoreChannel = <TDomain extends "host" | "remote">(
  domain: TDomain,
  config?: {
    onFullscreenChanged?: (enabled: boolean) => void;
    onFullscreenRequested?: () => void;
    onHtmlRedeliveryRequested?: () => void;
    onDeleteRequested?: () => void;
  }
) => {
  return createChannelDescriptor(domain, "core", {
    remoteMethods: () => {
      let appendAbortController: AbortController | null = null;
      const prototypeHostId = SKETCH_HOST_ID;
      return {
        deliverHtml: async (html: string) => {
          const hostEl = document.getElementById(prototypeHostId);
          if (!hostEl) {
            console.error("[rpc:host] deliverHtml: host element not found");
            return;
          }
          appendAbortController?.abort();
          appendAbortController = new AbortController();
          hostEl.innerHTML = "";
          await appendHtml(html, hostEl, {
            signal: appendAbortController.signal,
          });
        },
        setFullscreenMode: async (enabled: boolean) => {
          document.documentElement.classList.toggle(
            "fullscreen__sketch",
            enabled
          );
        },
      };
    },
    hostMethods: () => ({
      requestFullscreen: async () => {
        config?.onFullscreenRequested?.();
      },
      notifyFullscreenChanged: async (enabled: boolean) => {
        config?.onFullscreenChanged?.(enabled);
      },
      requestHtmlRedelivery: async () => {
        config?.onHtmlRedeliveryRequested?.();
      },
      requestDelete: async () => {
        config?.onDeleteRequested?.();
      },
    }),
  });
};
